import { PureComponent, ReactNode } from 'react';
import LeftBar from '../../components/common/NavBar';
import { Helmet } from 'react-helmet';
import { RouteComponentProps } from 'react-router-dom';
import HomePage from './HomePage';
import BankPage from './BankPage';
import FinishPage from './FinishPage';
import PancardPage from './PancardPage';
import StaffPage from './StaffPage';
import { captureError, captureErrorString } from '../captureError';
import getHEOnboardingProfile from '../../api/getHEOnboardingProfile';
import { GO_TO_HE_ONBOARDING } from '../../routes/paths';
import { track } from '../../tracking';
import { FetchingLoader } from './Utils';
import { isOnboardedForLab, isOnboardedForPharma } from '../utils';

export type HEOnboardingState = 'home' | 'bank' | 'pancard' | 'staff' | 'finish' | '';
export const heOnboardingStepsArray: HEOnboardingState[] = [
    'home',
    'bank',
    'pancard',
    'staff',
    'finish',
];

type RouterProps = {
    state: HEOnboardingState;
};

type Props = RouteComponentProps<RouterProps>;

interface State {
    isFetchingProfile?: boolean;
}

class HEOnboarding extends PureComponent<Props, State> {
    componentDidMount = async (): Promise<void> => {
        const { match, history } = this.props;
        const { state } = match.params;
        if (state) {
            return;
        }
        try {
            const { success, profile, error = '' } = await getHEOnboardingProfile();
            if (success && profile) {
                const { lastStep } = profile;
                if (lastStep && (isOnboardedForPharma() || isOnboardedForLab())) {
                    history.replace(GO_TO_HE_ONBOARDING(lastStep as HEOnboardingState));
                } else {
                    history.replace(GO_TO_HE_ONBOARDING('home'));
                }
            } else {
                captureErrorString(error);
                track('ERROR', { on: 'getHEOnboardingProfile', what: error });
            }
        } catch (error) {
            captureError(error as Error);
            track('ERROR', {
                on: 'getHEOnboardingProfile',
                error: (error as Error).message,
            });
        }
    };

    renderRightPanel = (): JSX.Element | undefined => {
        const { match } = this.props;
        const { state } = match.params;

        switch (state) {
            case 'home':
                return <HomePage />;
            case 'bank':
                return <BankPage />;
            case 'pancard':
                return <PancardPage />;
            case 'staff':
                return <StaffPage />;
            case 'finish':
                return <FinishPage />;
            default:
                return <FetchingLoader isFetchingProfile={true} />;
        }
    };

    render(): ReactNode {
        const { renderRightPanel } = this;
        return (
            <div className="flex flex-col w-full h-full bg-white font-lato he-onboarding">
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>EKA - HE Onboarding</title>
                </Helmet>

                <div className="grid h-full overflow-x-auto overflow-y-hidden grid-cols-queueGrid min-w-840 undefined">
                    <LeftBar />
                    <div className="relative flex items-center h-full col-span-11 overflow-scroll select-none">
                        {renderRightPanel()}
                    </div>
                </div>
            </div>
        );
    }
}

export default HEOnboarding;
